/* ==========================================================================
   KAELIX — theme behaviour
   Vanilla JS only. No framework runtime.
   ========================================================================== */
(function () {
  'use strict';

  var SELECTORS = {
    header: '[data-header]',
    mobileNav: '[data-mobile-nav]',
    mobileToggle: '[data-mobile-toggle]',
    cartDrawer: '[data-cart-drawer]',
    cartToggle: '[data-cart-toggle]',
    cartClose: '[data-cart-drawer-close]',
    overlay: '[data-overlay]',
    live: '[data-live-region]',
    accordion: '[data-accordion]',
    accordionTrigger: '.accordion__trigger',
    accordionPanel: '.accordion__panel',
    gallery: '[data-gallery]',
    galleryStage: '[data-gallery-stage]',
    galleryThumb: '[data-gallery-thumb]',
    galleryPrev: '[data-gallery-prev]',
    galleryNext: '[data-gallery-next]',
    galleryCount: '[data-gallery-count]',
    qty: '[data-quantity]',
    qtyInput: '[data-quantity-input]',
    qtyMinus: '[data-quantity-minus]',
    qtyPlus: '[data-quantity-plus]',
    price: '[data-price-target]',
    lightbox: '[data-lightbox]',
    announcement: '[data-announcement]'
  };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function announce(message) {
    var region = $(SELECTORS.live);
    if (region && message) region.textContent = message;
  }

  function money(cents) {
    var format = (window.KAELIX && window.KAELIX.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*amount\s*\}\}/, withCommas)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
                 .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas.replace('.', ','))
                 .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString());
  }

  /* ---------------- Overlay + drawer helpers ---------------- */
  var overlay = $(SELECTORS.overlay);
  var openSurfaces = [];

  function syncOverlay() {
    if (!overlay) return;
    if (openSurfaces.length) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
      document.body.style.overflow = 'hidden';
    } else {
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        if (!openSurfaces.length) overlay.hidden = true;
      }, 260);
    }
  }

  function registerSurface(el) {
    if (openSurfaces.indexOf(el) === -1) openSurfaces.push(el);
    syncOverlay();
  }
  function unregisterSurface(el) {
    openSurfaces = openSurfaces.filter(function (item) { return item !== el; });
    syncOverlay();
  }

  /* ---------------- Mobile navigation ---------------- */
  function initMobileNav() {
    var toggle = $(SELECTORS.mobileToggle);
    var nav = $(SELECTORS.mobileNav);
    if (!toggle || !nav) return;

    function closeNav() {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      unregisterSurface(nav);
    }

    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) registerSurface(nav); else unregisterSurface(nav);
    });

    $$('[data-mobile-nav-close]', nav).forEach(function (btn) {
      btn.addEventListener('click', closeNav);
    });

    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeNav();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeNav();
        toggle.focus();
      }
    });
  }

  /* ---------------- Accordions ---------------- */
  /* The trigger may be wrapped in a heading, so resolve its panel through
     aria-controls first and only fall back to the next sibling. */
  function accordionPanelFor(trigger) {
    var id = trigger.getAttribute('aria-controls');
    if (id) {
      var referenced = document.getElementById(id);
      if (referenced && referenced.classList.contains('accordion__panel')) return referenced;
    }
    var next = trigger.nextElementSibling;
    return (next && next.classList.contains('accordion__panel')) ? next : null;
  }

  function initAccordions(scope) {
    $$(SELECTORS.accordion, scope).forEach(function (group) {
      var single = group.getAttribute('data-accordion') === 'single';
      $$(SELECTORS.accordionTrigger, group).forEach(function (trigger) {
        var panel = accordionPanelFor(trigger);
        if (!panel) return;

        if (trigger.getAttribute('aria-expanded') === 'true') {
          panel.setAttribute('data-open', '');
          panel.style.height = 'auto';
        }

        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (single && !isOpen) {
            $$(SELECTORS.accordionTrigger, group).forEach(function (other) {
              if (other === trigger) return;
              other.setAttribute('aria-expanded', 'false');
              var otherPanel = accordionPanelFor(other);
              if (otherPanel) {
                otherPanel.style.height = otherPanel.scrollHeight + 'px';
                requestAnimationFrame(function () { otherPanel.style.height = '0px'; });
                otherPanel.removeAttribute('data-open');
              }
            });
          }
          togglePanel(trigger, panel, !isOpen);
        });
      });
    });
  }

  function togglePanel(trigger, panel, open) {
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.setAttribute('data-open', '');
      panel.style.height = panel.scrollHeight + 'px';
      panel.addEventListener('transitionend', function handler() {
        if (trigger.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
        panel.removeEventListener('transitionend', handler);
      });
    } else {
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.height = '0px'; });
      panel.removeAttribute('data-open');
    }
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery(scope) {
    $$(SELECTORS.gallery, scope).forEach(function (gallery) {
      var stage = $(SELECTORS.galleryStage, gallery);
      var thumbs = $$(SELECTORS.galleryThumb, gallery);
      if (!stage || !thumbs.length) return;
      var index = 0;

      function update(next) {
        index = (next + thumbs.length) % thumbs.length;
        var thumb = thumbs[index];
        var img = $('img', thumb);
        if (!img) return;
        var src = img.getAttribute('data-full') || img.currentSrc || img.src;
        var srcset = img.getAttribute('data-srcset') || img.getAttribute('srcset');
        var alt = img.getAttribute('data-alt') || img.alt || '';
        var stageImg = $('img', stage);
        if (stageImg) {
          stageImg.src = src;
          if (srcset) stageImg.setAttribute('srcset', srcset); else stageImg.removeAttribute('srcset');
          stageImg.alt = alt;
        }
        thumbs.forEach(function (item, i) {
          item.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        var counter = $(SELECTORS.galleryCount, gallery);
        if (counter) {
          var pad = function (n) { return (n < 10 ? '0' : '') + n; };
          counter.textContent = pad(index + 1) + ' / ' + pad(thumbs.length);
        }
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { update(i); });
      });

      var prev = $(SELECTORS.galleryPrev, gallery);
      var next = $(SELECTORS.galleryNext, gallery);
      if (prev) prev.addEventListener('click', function () { update(index - 1); });
      if (next) next.addEventListener('click', function () { update(index + 1); });

      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') update(index - 1);
        if (e.key === 'ArrowRight') update(index + 1);
      });

      // Touch swipe on the stage
      var startX = 0;
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 45) update(delta > 0 ? index - 1 : index + 1);
      }, { passive: true });
    });
  }

  /* ---------------- Lightbox ---------------- */
  function initLightbox(scope) {
    scope = scope || document;
    if (!document.body.hasAttribute('data-lightbox-enabled')) return;
    $$(SELECTORS.galleryStage, scope).forEach(function (stage) {
      stage.addEventListener('click', function (e) {
        if (e.target.closest('button')) return;
        var img = $('img', stage);
        if (!img) return;
        var dialog = document.createElement('div');
        dialog.className = 'lightbox';
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');
        dialog.setAttribute('aria-label', 'Product image');
        dialog.innerHTML = '<button type="button" class="lightbox__close btn btn--gallery btn--icon" aria-label="Close image">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
          '<img src="' + (img.currentSrc || img.src) + '" alt="' + (img.alt || '') + '">';
        document.body.appendChild(dialog);
        document.body.style.overflow = 'hidden';
        dialog.addEventListener('click', function (ev) {
          if (ev.target === dialog || ev.target.closest('.lightbox__close')) close();
        });
        function close() {
          document.body.style.overflow = '';
          dialog.remove();
          document.removeEventListener('keydown', onKey);
        }
        function onKey(ev) { if (ev.key === 'Escape') close(); }
        document.addEventListener('keydown', onKey);
        $('.lightbox__close', dialog).focus();
      });
    });
  }

  /* ---------------- Quantity selectors ---------------- */
  function initQuantities(scope) {
    $$(SELECTORS.qty, scope).forEach(function (wrapper) {
      var input = $(SELECTORS.qtyInput, wrapper);
      var minus = $(SELECTORS.qtyMinus, wrapper);
      var plus = $(SELECTORS.qtyPlus, wrapper);
      if (!input) return;
      function set(value) {
        var num = Math.max(1, parseInt(value, 10) || 1);
        input.value = num;
      }
      if (minus) minus.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
    });
  }

  /* ---------------- Header cart count ---------------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  /* ---------------- Cart drawer ---------------- */
  function CartDrawer() {
    var drawer = $(SELECTORS.cartDrawer);
    if (!drawer) return null;
    var body = $('[data-cart-drawer-body]', drawer);
    var footer = $('[data-cart-drawer-footer]', drawer);
    var subtotalEl = $('[data-cart-subtotal]', drawer);

    function open() {
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      registerSurface(drawer);
      var closeBtn = $(SELECTORS.cartClose, drawer);
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      unregisterSurface(drawer);
    }

    function bindRemove() {
      $$('[data-cart-remove]', drawer).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('[data-cart-line]');
          if (line) line.classList.add('is-loading');
          changeLine(btn.getAttribute('data-line'), 0);
        });
      });
      $$(SELECTORS.qty, drawer).forEach(function (wrapper) {
        var input = $(SELECTORS.qtyInput, wrapper);
        var line = wrapper.getAttribute('data-line');
        var minus = $(SELECTORS.qtyMinus, wrapper);
        var plus = $(SELECTORS.qtyPlus, wrapper);
        if (minus) minus.addEventListener('click', function () { changeLine(line, Math.max(0, parseInt(input.value, 10) - 1)); });
        if (plus) plus.addEventListener('click', function () { changeLine(line, parseInt(input.value, 10) + 1); });
      });
    }

    function render(cart) {
      updateCartCount(cart.item_count);
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
      if (body) body.innerHTML = cart.item_count > 0 ? lineItems(cart) : emptyState();
      if (footer) footer.hidden = cart.item_count === 0;
      bindRemove();
    }

    function lineItems(cart) {
      return '<div class="cart-lines">' + cart.items.map(function (item) {
        var image = item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="160" height="160">' : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
        return '<div class="cart-line" data-cart-line>' +
          '<a class="cart-line__media" href="' + item.url + '">' + image + '</a>' +
          '<div><a class="cart-line__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' + variant +
          '<p class="cart-line__price">' + money(item.final_line_price) + '</p>' +
          '<div class="cart-line__actions">' +
            '<div class="quantity-selector" data-quantity data-line="' + item.key + '">' +
              '<button type="button" class="quantity-selector__button" data-quantity-minus aria-label="Decrease quantity">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14"/></svg></button>' +
              '<input class="quantity-selector__input" data-quantity-input type="number" value="' + item.quantity + '" min="0" aria-label="Quantity for ' + escapeHtml(item.product_title) + '" readonly>' +
              '<button type="button" class="quantity-selector__button" data-quantity-plus aria-label="Increase quantity">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 5v14M5 12h14"/></svg></button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-cart-remove data-line="' + item.key + '">Remove</button>' +
          '</div></div></div>';
      }).join('') + '</div>';
    }

    function emptyState() {
      return '<div class="cart-drawer__empty"><p>Your cart is empty.</p>' +
        '<a class="btn btn--premium mt-6" href="{{ routes.all_products_collection_url }}">Continue shopping</a></div>';
    }

    function changeLine(line, quantity) {
      fetch(window.KAELIX.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); })
        .catch(function () { announce('Cart could not be updated. Please refresh.'); });
    }

    return { open: open, close: close, render: render };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------------- Data-driven cart mutation ---------------- */
  function addToCart(formData) {
    return fetch(window.KAELIX.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (r) { return r.json(); });
  }

  function initProductForms(cart, scope) {
    $$('form[data-product-form]', scope).forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var submit = $('[data-add-to-cart]', form);
        var note = $('[data-form-note]', form);
        var original = submit ? submit.innerHTML : '';
        if (submit) { submit.setAttribute('disabled', 'disabled'); submit.innerHTML = 'Adding…'; }
        var data = new FormData(form);

        addToCart(data)
          .then(function (response) {
            if (response && response.status) {
              announce(response.description || 'Unable to add to cart.');
              if (note) note.textContent = response.description || 'Unable to add to cart.';
              if (submit) { submit.removeAttribute('disabled'); submit.innerHTML = original; }
              return;
            }
            announce('Added to cart.');
            if (note) note.textContent = 'Added to cart.';
            var cartUrl = window.KAELIX.routes.cart + '.js';
            fetch(cartUrl).then(function (r) { return r.json(); }).then(function (state) {
              updateCartCount(state.item_count);
              if (cart) cart.render(state);
              if (window.KAELIX.cartDrawer && cart) cart.open();
            });
            if (submit) { submit.removeAttribute('disabled'); submit.innerHTML = original; }
            if (response && response.sections) {
              var bubble = document.getElementById('cart-icon-bubble');
              if (bubble && response.sections['cart-icon-bubble']) {
                bubble.innerHTML = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html').getElementById('cart-icon-bubble').innerHTML;
              }
            }
          })
          .catch(function () {
            if (note) note.textContent = 'Something went wrong. Please try again.';
            if (submit) { submit.removeAttribute('disabled'); submit.innerHTML = original; }
          });
      });
    });
  }

  /* ---------------- Announcement rotation ---------------- */
  function initAnnouncement() {
    var bar = $(SELECTORS.announcement);
    if (!bar) return;
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var current = 0;
    items[0].classList.add('is-active');
    window.setInterval(function () {
      items[current].classList.remove('is-active');
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');
    }, 6000);
  }

  /* ---------------- Header shadow on scroll ---------------- */
  function initHeaderScroll() {
    var header = $(SELECTORS.header);
    if (!header) return;
    var threshold = 8;
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Boot ---------------- */
  var storeCart = null;

  function boot() {
    var cart = CartDrawer();
    storeCart = cart;
    initMobileNav();
    initAccordions();
    initGallery();
    initQuantities();
    initProductForms(cart);
    initAnnouncement();
    initHeaderScroll();
    initLightbox();

    if (cart) {
      $$(SELECTORS.cartToggle).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          cart.open();
        });
      });
      $$(SELECTORS.cartClose).forEach(function (btn) {
        btn.addEventListener('click', function () { cart.close(); });
      });
    }
    if (overlay) {
      overlay.addEventListener('click', function () {
        var drawer = $(SELECTORS.cartDrawer);
        if (drawer && drawer.classList.contains('is-open')) {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          unregisterSurface(drawer);
        }
        var nav = $(SELECTORS.mobileNav);
        if (nav && nav.classList.contains('is-open')) {
          nav.classList.remove('is-open');
          var t = $(SELECTORS.mobileToggle);
          if (t) t.setAttribute('aria-expanded', 'false');
          unregisterSurface(nav);
        }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var drawer = $(SELECTORS.cartDrawer);
        if (drawer && drawer.classList.contains('is-open')) {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          unregisterSurface(drawer);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event.target || document;
    initAccordions(scope);
    initGallery(scope);
    initQuantities(scope);
    initProductForms(storeCart, scope);
    initLightbox(scope);
  });
})();
